import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { BackdropLoader } from '@livable/saas-react-components';
import { Paper } from '@mui/material';
import { PaymentMethod } from 'src/components/settings/PaymentMethod';
import { PayGateModal } from 'src/components/utilities/PayGateModal';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const PaymentInformationTab = observer(() => {
  const classes = useStyles();
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    companyProperties = _useState4[0],
    setCompanyProperties = _useState4[1];
  const canBeModified = true;
  useEffect(() => {
    setIsLoading(true);
    const getAutopayMethod = async () => {
      const resp = await store.payment.getAutopayMethodAsync.run();
      return resp;
    };
    const getPaymentMethods = async () => {
      const resp = await store.payment.getPaymentMethodsV2Async.run({
        applyToHomeDashboard: false
      });
      return resp;
    };
    const getCompanyProperties = async () => {
      const resp = await store.company.getCompanyPropertiesAsync.run();
      return resp;
    };
    let promises = [getAutopayMethod(), getPaymentMethods(), getCompanyProperties()];
    Promise.all([...promises]).then(resp => {
      if (resp && resp[2] && resp[2].response) {
        const result = {};
        resp[2].response.map(item => {
          result[item.propertyId] = item.propertyAddress;
        });
        setCompanyProperties(result);
      }
    }).finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapper
  }, store.payment.paymentMethods.map(method => {
    const currentAssignedProperty = [];
    method.assignedPropertyIds.map(item => {
      if (companyProperties[item]) currentAssignedProperty.push(companyProperties[item]);
    });
    return /*#__PURE__*/React.createElement(PaymentMethod, {
      canBeModified: canBeModified,
      isFailed: method.isFailed,
      isNotVerified: !method.isVerified && !method.isFailed,
      method: method,
      key: method.id,
      assignedProperty: currentAssignedProperty
    });
  }), canBeModified && /*#__PURE__*/React.createElement(Paper, {
    variant: "basic"
  }, isLoading ? /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: true
  }) : /*#__PURE__*/React.createElement(PayGateModal, {
    trigger: true
  })));
});